import { updateSystemSettings } from '../../services/config/admin/LocalConfigParam';
import { celebrateParser } from '../../utils/celebrateParser';
import { parseFetchError } from '../../utils/http';
import { config } from '../../config';
import { getStoredToken } from '../user/SessionChecker';
import { appConfig } from 'config/app';
/*import ActionTypes from 'app/components/AppDrawer/slice/constants';
import { appStore } from 'store/configureStore';
import { changeUserInSession } from 'app/components/AppDrawer/slice/actions';
*/
export const sendRequest = (url, data, stringify, headers) => {
  const token = getStoredToken();

  return new Promise(async (resolve, reject) => {
    try {
      if (!headers) {
        headers = {
          'Access-Control-Allow-Origin': config.serverDomain,
          'Access-Control-Allow-Headers':
            'Origin, X-Requested-With, Content-Type, Accept',
          Accept: 'application/json',
          'Content-Type': 'application/json',
        };
      }
      if (token) {
        headers.Authorization = config.jwtTokenStoreName + ' ' + token;
      }
      const res = await fetch(url, {
        headers: headers,
        credentials: 'include',
        method: 'POST',
        body: stringify ? JSON.stringify(data) : data,
      }).catch(err => {
        reject({ respCode: -1, detailedMessage: err.stack });
      });

      const dataOut = await res.json();

      if (
        dataOut.respCode === config.httpStatusCodes.UNAUTHORIZED ||
        dataOut.statusCode === config.httpStatusCodes.UNAUTHORIZED ||
        dataOut.status === config.httpStatusCodes.UNAUTHORIZED
      ) {
        localStorage.removeItem(config.jwtTokenStoreName);
        localStorage.removeItem(config.localUserDTO);

        document.location.href = config.redirectUrlForUnAuthorizedUsers;
        return;
        //appStore.dispatch(changeUserInSession(false));
      }

      if (dataOut.data && dataOut.data.token) {
        console.log('updating token');
        localStorage.setItem(config.jwtTokenStoreName, dataOut.data.token);
      }
      if (dataOut.data && dataOut.data.systemSettings) {
        console.log('updating system settings');
        updateSystemSettings(dataOut.data.systemSettings);
      }

      celebrateParser(dataOut);

      if (res && res.ok) {
        resolve(dataOut);
      } else {
        reject(dataOut);
      }
    } catch (e) {
      reject({
        respCode: -1,
        message: parseFetchError(e),
      });
    }
  });
};

export const sendJSONRequest = (url, data, headers) => {
  return sendRequest(url, data, true, headers);
};

export const sendMultiPartRequest = (url, data) => {
  // No se define el header Content-Type': 'multipart/form-data'
  // fetch internamente lo hace, de lo contrario fallará el envío
  const headers = {
    'Access-Control-Allow-Origin': config.serverDomain,
    'Access-Control-Allow-Headers':
      'Origin, X-Requested-With, Content-Type, Accept',
    Accept: 'application/json',
  };
  return sendRequest(url, data, false, headers);
};

export const sendMultiPartJSONRequest = (url, data) => {
  // No se define el header Content-Type': 'multipart/form-data'
  // fetch internamente lo hace, de lo contrario fallará el envío
  const headers = {
    'Access-Control-Allow-Origin': config.serverDomain,
    'Access-Control-Allow-Headers':
      'Origin, X-Requested-With, Content-Type, Accept',
    Accept: 'application/json',
  };
  return sendRequest(url, data, true, headers);
};
